import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Lightbulb, ChevronDown, ArrowRight } from "lucide-react";

// Collapses the home helper blocks (tips, examples, 50 cas pratiques) behind one slim bar.
export function ExtrasDrawer({ children }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const items = React.Children.toArray(children);
  return (
    <>
      <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="home-extras-toggle"
        className="mx-6 md:mx-8 lg:mx-10 mt-6 flex items-center justify-between gap-3 border border-[#002FA7]/40 bg-[#002FA7]/5 px-4 py-3 text-left hover:bg-[#002FA7]/10 transition-colors">
        <span className="flex items-center gap-2 text-sm">
          <Lightbulb className="w-4 h-4 text-[#002FA7] shrink-0" />
          <span><b>{t("extras.title", "Idées et exemples")}</b> · {t("extras.subtitle", "astuces, textes d'essai, 50 cas pratiques")}</span>
        </span>
        <ChevronDown className={`w-4 h-4 text-[#002FA7] shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid="home-extras-panel">
          {items}
          <Link to="/enseignants/cas-pratiques" data-testid="home-extras-cases-link"
            className="mx-6 md:mx-8 lg:mx-10 mt-3 flex items-center justify-between gap-3 border border-border px-4 py-3 text-sm hover:border-[#002FA7] hover:text-[#002FA7] transition-colors">
            <span><b>{t("extras.cases", "Les 50 cas pratiques")}</b> · {t("extras.cases_sub", "élèves, parents, professeurs, étudiants")}</span>
            <ArrowRight className="w-4 h-4 shrink-0" />
          </Link>
        </div>
      )}
    </>
  );
}

export default ExtrasDrawer;
